<script>
  import Entity from "./Entity.svelte";
  export let entities = [];
</script>

<style>
  .list-wrap {
    display: flex;
    justify-content: center;
    margin: 1rem;
    gap: 0.25rem;
    flex-wrap: wrap;
    width: 100%;
  }
</style>

<div class="list-wrap">
  {#each entities as entity}
  <Entity entity={entity}/>
  {/each}
</div>